import {ApiError, ErrorCode, ErrorResponse} from '../types';
import {HttpError} from '../middleware';

/**
 * Formats an error into a standardized error response
 */
export function formatError(
  error: Error | ApiError,
  includeStack = false,
  correlationId?: string
): ErrorResponse {
  // Default error response
  const errorResponse: ErrorResponse = {
    success: false,
    message: error.message || 'An unexpected error occurred',
    code: ErrorCode.INTERNAL_ERROR
  };

  // If it's an ApiError, add specific fields
  const apiError = error as ApiError;
  if (apiError.code) {
    errorResponse.code = apiError.code;
  }

  if (apiError.details) {
    errorResponse.details = apiError.details;
  }

  // Add correlation ID if provided
  if (correlationId) {
    errorResponse.correlationId = correlationId;
  }

  // Add stack trace if enabled and available
  if (includeStack && error.stack) {
    errorResponse.stack = error.stack;
  }

  return errorResponse;
}

/**
 * Convert any error to an ApiError
 */
export function normalizeError(error: any, defaultStatusCode = 500, defaultCode: ErrorCode = ErrorCode.INTERNAL_ERROR): ApiError {
  // If already an API error, return as is
  if (error && typeof error === 'object' && 'statusCode' in error && 'code' in error) {
    return error as ApiError;
  }

  // Convert to HTTP error
  let message = 'An unexpected error occurred';

  if (error instanceof Error) {
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  } else if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
    message = error.message;
  }

  return new HttpError(message, defaultStatusCode, defaultCode);
}
